<template>
    <TableLaborDashboard></TableLaborDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TableLaborDashboard = defineAsyncComponent(() =>
    import("../../components/Hr/LaborDashboard/Table.vue")
);
export default {
    name: "Labor_Dashboard",
    components: { TableLaborDashboard, AuthLayout },
};
</script>
